// Shared date/time helpers + DateTimeControl (used by AddStock & BatchImport).
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
export const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

// Local (not UTC) YYYY-MM-DD — critical for user-facing "today".
// Honours the user's stored timezone (from Réglages → Profil) if present so
// the "today" shown on Dashboard matches the trading day the user experiences,
// not the browser's local clock. Falls back to browser local.
export const todayIso = () => {
  const tz = typeof localStorage !== "undefined" ? localStorage.getItem("geni_timezone") : null;
  const d = new Date();
  if (tz) {
    try {
      // en-CA locale always yields YYYY-MM-DD when parts are formatted.
      const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
      }).formatToParts(d);
      const y = parts.find((p) => p.type === "year")?.value;
      const m = parts.find((p) => p.type === "month")?.value;
      const day = parts.find((p) => p.type === "day")?.value;
      if (y && m && day) return `${y}-${m}-${day}`;
    } catch {
      /* invalid tz → fall back to browser local */
    }
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
export const pad = (n) => String(n).padStart(2, "0");

export function nowHM() {
  const d = new Date();
  return { h: pad(d.getHours()), m: pad(d.getMinutes()) };
}
export function combineDateHM(dateStr, h, m) {
  const [Y, Mo, D] = dateStr.split("-").map(Number);
  const d = new Date(Y, Mo - 1, D, Number(h || 0), Number(m || 0), 0, 0);
  return d.toISOString();
}

export function DateTimeControl({ date, hour, minute, onChange, testIdPrefix }) {
  return (
    <div className="grid grid-cols-[1fr_auto_auto] gap-2 items-center">
      <Input
        type="date"
        value={date}
        onChange={(e) => onChange({ date: e.target.value, hour, minute })}
        className="h-10 bg-input border-line-strong font-mono-num"
        data-testid={`${testIdPrefix}-date`}
      />
      <Select value={hour} onValueChange={(v) => onChange({ date, hour: v, minute })}>
        <SelectTrigger className="h-10 w-[76px] bg-input border-line-strong font-mono-num" data-testid={`${testIdPrefix}-hour`}>
          <SelectValue placeholder="HH" />
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {HOURS.map((v) => <SelectItem key={v} value={v}>{v}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={minute} onValueChange={(v) => onChange({ date, hour, minute: v })}>
        <SelectTrigger className="h-10 w-[76px] bg-input border-line-strong font-mono-num" data-testid={`${testIdPrefix}-minute`}>
          <SelectValue placeholder="MM" />
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {MINUTES.map((v) => <SelectItem key={v} value={v}>{v}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
